// Module
var code = `<div class="inc-exp" id="inc-exp"> <div class="inc" id="item-income"> <p>Income:</p> <span id="income_amount"></span> </div> <div class="exp" id="item-expense"> <p>Expense:</p> <span id="expense_amount"></span> </div> </div> `;
// Exports
export default code;